import { thousand } from '../../../utils/format';

export const getChartOptions = (label = '', unit = '') => ({
  responsive: true,
  legend: false,
  scales: {
    xAxes: [
      {
        offset: true,
        gridLines: false,
        ticks: {
          maxRotation: 45,
          minRotation: 45,
        },
      },
    ],
    yAxes: [
      {
        scaleLabel: {
          display: true,
          labelString: label,
          padding: { bottom: 20 },
        },
        offset: true,
        gridLines: { drawBorder: false },
        ticks: { beginAtZero: true },
      },
    ],
  },
  tooltips: {
    displayColors: false,
    titleMarginBottom: 5,
    backgroundColor: '#fff',
    position: 'average',
    titleFontColor: '#666',
    bodyFontColor: '#666',
    borderColor: '#ededed',
    borderWidth: 1,
    callbacks: {
      title: function (tooltipItems) {
        return thousand(tooltipItems[0].value) + ' ' + unit;
      },
      label: function (tooltipItem) {
        return tooltipItem.xLabel.join(' ');
      },
    },
    titleFontSize: 15,
    xPadding: 15,
    yPadding: 10,
    titleAlign: 'center',
    bodyAlign: 'center',
  },
});


export const dataMonths = [
  { label : 'Januari',value : 1 },
  { label : 'Februari',value : 2 },
  { label : 'Maret',value : 3 },
  { label : 'April',value : 4 },
  { label : 'Mei',value : 5 },
  { label : 'Juni',value : 6 },
  { label : 'Juli',value : 7 },
  { label : 'Agustus',value : 8 },
  { label : 'September',value : 9 },
  { label : 'Oktober',value : 10 },
  { label : 'November',value : 11 },
  { label : 'Desember',value : 12 },
];
